import {Component, h} from "preact";
import styles from './style.module.scss';

interface Props {
  disabled?: boolean;
  label: string;
  onClickCallback: (e?: Event) => void;
  white?: boolean;
  grey?: boolean;
  black?: boolean;
  red?: boolean;
  text?: boolean;
  svg?: any;
}

export default class Button extends Component<Props> {

  render() {
    const style = this.getClassesFromProps();

    if (this.props.svg) {
      return (
        <button class={style}
                disabled={this.props.disabled}
                onClick={this.props.onClickCallback}>
          <div class={styles['button-content']}>
            <span>{this.props.svg}</span>
            {this.props.label}
          </div>
        </button>
      )
    } else {
      return (
        <button class={style}
                disabled={this.props.disabled}
                onClick={this.props.onClickCallback}>{this.props.label}</button>
      )
    }
  }

  getClassesFromProps(): string {
    let classNames = [];
    classNames.push(styles['button']);
    if (this.props.white) {
      classNames.push(styles['white']);
    }
    if (this.props.grey) {
      classNames.push(styles['grey']);
    }
    if (this.props.black) {
      classNames.push(styles['black']);
    }
    if (this.props.red) {
      classNames.push(styles['red']);
    }
    if (this.props.text) {
      classNames.push(styles['text']);
    }
    return classNames.join(' ');
  }

}